<template>
    <section class="entity-dashboard dashboard">
        <div
            class="select-organization"
            v-if="isAdmin && dashboardTab === 'entity'"
        >
            <vs-select
                autocomplete
                label="Empresa"
                v-model="scopedOrganizationId"
            >
                <vs-select-item
                    v-for="(org, index) in organizations"
                    :key="index"
                    :value="org.id"
                    :text="org.businessName"
                />
            </vs-select>
        </div>
        <div
            class="alert info"
            v-if="
                isAdmin &&
                dashboardTab === 'entity' &&
                scopedOrganizationId === 0
            "
        >
            <vs-icon icon="info" />
            Es necesario que seleccione una entidad para acceder a las
            estádisticas
        </div>
        <div class="dashboard__data" v-else>
            <div class="input-group subtype" v-if="isMix">
                <div class="we-toggle-text">
                    <div
                        :class="{ active: selected === 'buy' }"
                        @click="
                            selected = 'buy';
                            filterGlobal();
                        "
                    >
                        Comprador
                    </div>
                    <div
                        :class="{ active: selected === 'sell' }"
                        @click="
                            selected = 'sell';
                            filterGlobal();
                        "
                    >
                        Vendedor
                    </div>
                </div>
            </div>
            <CardsDashboard
                :hideFilters="false"
                :dashboardTab="dashboardTab"
                :isAdmin="isAdmin"
                :organizations="organizations"
                :scopedOrganizationId="scopedOrganizationId"
                filterFor="cards"
                ref="cardsDashboard"
            />

            <ChartEntityDashboard
                :dashboardTab="dashboardTab"
                :isAdmin="isAdmin"
                :organizations="organizations"
                :scopedOrganizationId="scopedOrganizationId"
                ref="chartEntityDashboard"
            />

            <RankingDashboard
                :dashboardTab="dashboardTab"
                :isAdmin="isAdmin"
                :organizations="organizations"
                :scopedOrganizationId="scopedOrganizationId"
            />

            <CalendarDashboard
                v-if="currentUser.canBuy || currentUser.admin"
                userRole="buyer"
                :dashboardTab="dashboardTab"
                :isAdmin="isAdmin"
                :organizations="organizations"
                :scopedOrganizationId="scopedOrganizationId"
            />

            <CalendarDashboard
                v-if="currentUser.canSell || currentUser.admin"
                userRole="seller"
                :dashboardTab="dashboardTab"
                :isAdmin="isAdmin"
                :organizations="organizations"
                :scopedOrganizationId="scopedOrganizationId"
            />
        </div>
    </section>
</template>

<script>
import DashboardFilters from "./DashboardFilters.vue";
import CardsDashboard from "./CardsDashboard.vue";
import ChartEntityDashboard from "./ChartEntityDashboard.vue";
import RankingDashboard from "./RankingDashboard.vue";
import CalendarDashboard from "./CalendarDashboard.vue";
import { mapMutations, mapState } from "vuex";
import gql from "graphql-tag";
import axios from "axios";
import { print } from "graphql";

const listOrganizations = gql`
    query listOrganizations(
        $currentUserToken: String!
        $dashboard: Boolean
        $page: Int
    ) {
        listOrganizations(
            currentUserToken: $currentUserToken
            dashboard: $dashboard
            page: $page
        ) {
            organizations {
                businessName
                id
            }
        }
    }
`;

export default {
    name: "entitytab",
    computed: {
        ...mapState({
            currentUser: (state) => state.User.currentUser,
        }),
    },
    props: {
        dashboardTab: {
            type: String,
            required: true,
        },
        isAdmin: {
            type: Boolean,
            required: false,
            default: false,
        },
        isMix: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    beforeMount() {
        this.getOrganizationId();
    },
    components: {
        DashboardFilters,
        CardsDashboard,
        ChartEntityDashboard,
        RankingDashboard,
        CalendarDashboard,
    },
    data() {
        return {
            organizations: [],
            scopedOrganizationId: 0,
            selected: "buy",
        };
    },
    methods: {
        getOrganizationId() {
            axios
                .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
                    params: {
                        query: print(listOrganizations),
                        variables: {
                            currentUserToken: localStorage.getItem(
                                "USER_TOKEN"
                            ),
                            dashboard: this.isAdmin,
                        },
                    },
                })
                .then((res) => {
                    if (!res.data.errors) {
                        this.organizations =
                            res.data.data.listOrganizations.organizations;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        filterGlobal() {
            this.$refs.cardsDashboard.filterByUser(this.selected);
            this.$refs.chartEntityDashboard.filterByUser(this.selected);
        },
        // inputChanged () {
        //   console.log(this.scopedOrganizationId)
        //   // if (this.ready) { //  READY ???????
        //   //   this.$emit('filter', this.scopedOrganizationId)
        //   // }
        // },
    },
};
</script>
